
import { getCourseResourceInfo } from '@/api/resources'

const catalog = {
  state: {
    catalogNamess:'',
    catalogSnss:'',
    slaveCabpid:'',
    catalogObj: '', // vuex中案例、图书当前选中的目录节点
    caseCatalogHandleNodes: [], // vuex中案例，图书当前展开的目录
    currentCourseCatalog: "", // vuex中当前选中的目录节点
    courseHandleNodes: [], // vuex中课程中当前展开的目录
    courseCatalogNode: "", // vue中课程中选中的资源节点（用于做获取不同类型的信息，结构为：{type: 'sp', data: {}}）
    courseResourceNode: "", // vuex中课程选中资源节点下对应的资源数据
    pdfCurrentCata:"",
    firstItem:"",
    imgList:"",
  },
  mutations: {
    // setSlaveCabpid:(state, slaveCabpid) => {
    //   state.slaveCabpid = slaveCabpid
    //   console.log("存值slaveCabpid",catalogNamess)
    // },
    setFirstItem: (state, firstItem) => {
      state.firstItem = firstItem
    },
    setPDFCurCata:(state, pdfCurrentCata) => {
      state.pdfCurrentCata = pdfCurrentCata
    },
    setcatalogNamess:(state, catalogNamess) => {
      state.catalogNamess = catalogNamess
      // console.log("存值catalogName",catalogNamess)
    },
    setcatalogSnss:(state, catalogSnss) => {
      state.catalogSnss = catalogSnss
      // console.log("存值catalogSn",catalogSnss)
    },
    setCatalogObj: (state, catalogObj) => {
      state.catalogObj = catalogObj
    },
    setCurrentCourseCatalog: (state, currentCourseCatalog) => {
      state.currentCourseCatalog = currentCourseCatalog
    //   console.log("currentCourseCatalogsss", currentCourseCatalog)
    },
    setCaseCatalogHandleNodes: (state, caseCatalogHandleNodes) => {
      state.caseCatalogHandleNodes = caseCatalogHandleNodes
    },
    addCaseCatalogHandleNode: (state, handleNode) => {
      state.caseCatalogHandleNodes.push(handleNode)
    },
    removeCaseCatalogHandleNode: (state, handleNode) => {
      for (let i = 0; i < state.caseCatalogHandleNodes.length; i++) {
        if (state.caseCatalogHandleNodes[i] === handleNode) {
          state.caseCatalogHandleNodes.splice(i, 1)
        }
      }
    },
    setCourseHandleNodes: (state, courseHandleNodes) => {
      state.courseHandleNodes = courseHandleNodes
    },
    addCourseHandleNode: (state, handleNode) => {
      state.courseHandleNodes.push(handleNode)
    },
    mobimgList: (state,imgList) => {
      state.imgList = imgList
      console.log('mobimgList2333',imgList)
    },
    removeCourseHandleNode: (state, handleNode) => {
      for (let i = 0; i < state.courseHandleNodes.length; i++) {
        if (state.courseHandleNodes[i] === handleNode) {
          state.courseHandleNodes.splice(i, 1)
        }
      }
    },
    removeAllCourseHandleNode: (state) => {
          state.courseHandleNodes = []
    },
    setCourseCatalogNode: (state, node) => {
      state.courseCatalogNode = node
    },
    setCourseResourceNode: (state, node) => {
      state.courseResourceNode = node
    }
  },
  actions: {
    /** 获取课程资源数据 */
    getCourseResourceInfo ({commit, state}, param) {
      return new Promise ((resolve, reject) => {
        getCourseResourceInfo(param).then(response => {
          const resultData = response.data
          let errorInfo = resultData.errorInfo
          if (errorInfo === 'success') {
            commit("setCourseResourceNode", resultData.data)
          }
          resolve(resultData)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default catalog



// WEBPACK FOOTER //
// ./src/store/modules/catalog.js